/* ============================================================
   Maurice Fine Jewelry — Theme JavaScript
   Megamenu, mobile nav drawer, cart drawer (AJAX), FAB,
   filter drawer, gallery thumb switching, legal TOC, account tabs.
   ============================================================ */

(function () {
  'use strict';

  // ---- Megamenu ----
  const trigger = document.querySelector('.nav__collections-trigger');
  const mega = document.getElementById('megamenu');
  if (trigger && mega) {
    let timer;
    const open = () => { clearTimeout(timer); mega.classList.add('is-open'); };
    const close = () => { timer = setTimeout(() => mega.classList.remove('is-open'), 140); };
    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('focus', open);
    mega.addEventListener('mouseenter', open);
    trigger.addEventListener('mouseleave', close);
    mega.addEventListener('mouseleave', close);
    trigger.addEventListener('click', (e) => {
      if (window.innerWidth <= 768) { e.preventDefault(); mega.classList.toggle('is-open'); }
    });
  }

  // ---- Contact FAB ----
  const fab = document.querySelector('.contact-fab');
  if (fab) {
    const btn = fab.querySelector('.contact-fab__btn');
    if (btn) {
      btn.addEventListener('click', () => {
        fab.dataset.state = fab.dataset.state === 'open' ? 'closed' : 'open';
      });
    }
    document.addEventListener('click', (e) => {
      if (fab && !fab.contains(e.target) && fab.dataset.state === 'open') {
        fab.dataset.state = 'closed';
      }
    });
  }

  // ---- Mobile Nav Drawer ----
  const mnav = document.querySelector('.mnav-drawer');
  const mnavBackdrop = document.querySelector('.mnav-backdrop');

  function openMnav() {
    if (!mnav) return;
    mnav.classList.add('is-open');
    if (mnavBackdrop) mnavBackdrop.classList.add('is-on');
    mnav.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeMnav() {
    if (!mnav) return;
    mnav.classList.remove('is-open');
    if (mnavBackdrop) mnavBackdrop.classList.remove('is-on');
    mnav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  const hamburger = document.querySelector('.nav__hamburger');
  if (hamburger) {
    hamburger.addEventListener('click', openMnav);
    hamburger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openMnav(); }
    });
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-mnav-close]')) {
      if (!e.target.closest('[data-cart-open]')) e.preventDefault();
      closeMnav();
    }
  });

  // Collections accordion inside mobile nav
  document.querySelectorAll('[data-mnav-acc]').forEach(acc => {
    const trig = acc.querySelector('.mnav-acc__trigger');
    if (trig) {
      trig.addEventListener('click', () => {
        const isOpen = acc.classList.toggle('is-open');
        trig.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }
  });

  // ---- Cart Drawer ----
  const drawer = document.querySelector('.cart-drawer');
  const cartBackdrop = document.querySelector('.cart-backdrop');

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (cartBackdrop) cartBackdrop.classList.add('is-on');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (cartBackdrop) cartBackdrop.classList.remove('is-on');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); }
  });

  // ---- AJAX Cart API ----
  function updateCartCount(count) {
    const el = document.getElementById('cart-count');
    if (el) el.textContent = count;
    const mel = document.getElementById('mnav-cart-count');
    if (mel) mel.textContent = count;
    document.body.setAttribute('data-cart', count);
    const noun = document.getElementById('cart-noun');
    if (noun) noun.textContent = count + (count === 1 ? ' piece' : ' pieces');
  }

  async function refreshCartDrawer() {
    try {
      const res = await fetch('/?sections=header', { headers: { 'Accept': 'application/json' } });
      const data = await res.json();
      if (data.header) {
        const tmp = document.createElement('div');
        tmp.innerHTML = data.header;
        const newBody = tmp.querySelector('#cart-body');
        const oldBody = document.getElementById('cart-body');
        if (newBody && oldBody) oldBody.innerHTML = newBody.innerHTML;
        const newNoun = tmp.querySelector('#cart-noun');
        const oldNoun = document.getElementById('cart-noun');
        if (newNoun && oldNoun) oldNoun.textContent = newNoun.textContent;
      }
    } catch (err) {
      console.warn('Cart refresh failed:', err);
    }
  }

  // Add to cart (AJAX)
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    const formData = new FormData(form);
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      });
      const item = await res.json();
      if (item.id) {
        // Fetch updated cart count
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        updateCartCount(cart.item_count);
        await refreshCartDrawer();
        openCart();
      }
    } catch (err) {
      console.error('Add to cart failed:', err);
    }
  });

  // Cart qty change (drawer + cart page)
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    e.preventDefault();
    const line = parseInt(btn.dataset.line, 10);
    const qty = parseInt(btn.dataset.qty, 10);
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: Math.max(0, qty) }),
      });
      const cart = await res.json();
      updateCartCount(cart.item_count);
      if (qty === 0) {
        const li = btn.closest('.cart-item');
        if (li) { li.style.opacity = '0'; setTimeout(() => li.remove(), 220); }
      }
      await refreshCartDrawer();
      // If on cart page, reload to update totals
      if (document.body.dataset.page === 'cart') {
        window.location.reload();
      }
    } catch (err) {
      console.error('Cart update failed:', err);
    }
  });

  // ---- Escape closes everything ----
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeCart();
      closeMnav();
      if (fab) fab.dataset.state = 'closed';
      // Close filter drawer if open
      const fdrawer = document.querySelector('.fdrawer');
      const fdBackdrop = document.querySelector('.fdrawer-backdrop');
      if (fdrawer && fdrawer.classList.contains('is-open')) {
        fdrawer.classList.remove('is-open');
        if (fdBackdrop) fdBackdrop.classList.remove('is-on');
        fdrawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }
  });

  // ---- PDP Gallery thumb switching ----
  const thumbs = document.querySelectorAll('.pdp__thumb[data-thumb-index]');
  const mainImg = document.getElementById('pdp-main-img');
  const imagesJson = document.getElementById('product-images-json');

  if (thumbs.length && mainImg && imagesJson) {
    try {
      const images = JSON.parse(imagesJson.textContent);
      thumbs.forEach(t => {
        t.addEventListener('click', () => {
          thumbs.forEach(x => x.classList.remove('is-on'));
          t.classList.add('is-on');
          const idx = parseInt(t.dataset.thumbIndex, 10);
          if (images[idx]) {
            mainImg.src = images[idx].url;
            mainImg.alt = images[idx].alt || '';
          }
        });
      });
    } catch (e) { /* ignore parse errors */ }
  }

  // ---- PDP Variant Selector ----
  (function () {
    const variantsJson = document.getElementById('product-variants-json');
    const productForm = document.querySelector('form[action="/cart/add"]');
    if (!variantsJson || !productForm) return;

    let variants;
    try { variants = JSON.parse(variantsJson.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    const optionSelects = productForm.querySelectorAll('select[name^="options["]');
    if (!optionSelects.length) return;

    const hiddenInput = productForm.querySelector('input[name="id"]');
    const addBtn = productForm.querySelector('[data-add-to-cart]');
    const priceEl = document.querySelector('.pdp__price-value');

    function getCurrentOptions() {
      const opts = [];
      optionSelects.forEach(sel => opts.push(sel.value));
      return opts;
    }

    function findVariant(opts) {
      return variants.find(v => {
        return v.options.every((o, i) => o === opts[i]);
      });
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function onOptionChange() {
      const opts = getCurrentOptions();
      const variant = findVariant(opts);
      if (!variant) {
        // No matching variant — disable button
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }

      // Update hidden variant ID
      if (hiddenInput) hiddenInput.value = variant.id;

      // Update price display
      if (priceEl && !priceEl.classList.contains('pdp__price-value--inquire')) {
        priceEl.textContent = formatMoney(variant.price);
      }

      // Update add-to-cart button
      if (addBtn) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.innerHTML = addBtn.closest('.pdp__cta')
            ? document.querySelector('.pdp__cta') && addBtn.dataset.addToCart !== undefined
              ? formatMoney(variant.price)
              : addBtn.textContent
            : addBtn.textContent;
          // Rebuild button text with price
          const addText = document.querySelector('[data-add-to-cart]');
          if (addText) addText.innerHTML = 'Add to Cart &nbsp;\u00B7&nbsp; ' + formatMoney(variant.price);
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'Sold Out';
        }
      }
    }

    optionSelects.forEach(sel => sel.addEventListener('change', onOptionChange));
  })();

  // ---- Collection sort select ----
  const sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  // ---- Desktop filter auto-submit on checkbox change ----
  const desktopFilterForm = document.querySelector('[data-filter-form]');
  if (desktopFilterForm) {
    desktopFilterForm.addEventListener('change', (e) => {
      if (e.target.matches('input[type="checkbox"]')) {
        desktopFilterForm.submit();
      }
    });
  }

  // ---- Mobile filter / sort drawer ----
  (function () {
    const fdrawer = document.querySelector('.fdrawer');
    const fdBackdrop = document.querySelector('.fdrawer-backdrop');
    const title = document.getElementById('fdrawer-title');
    if (!fdrawer || !fdBackdrop) return;

    const panes = fdrawer.querySelectorAll('[data-pane]');
    const foot = fdrawer.querySelector('.fdrawer__foot');

    function showPane(name) {
      panes.forEach(p => p.hidden = p.dataset.pane !== name);
      if (title) title.textContent = name === 'sort' ? 'Sort' : 'Filter';
      if (foot) foot.style.display = name === 'sort' ? 'none' : 'grid';
    }
    function fdOpen(name) {
      showPane(name);
      fdrawer.classList.add('is-open');
      fdBackdrop.classList.add('is-on');
      fdrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function fdClose() {
      fdrawer.classList.remove('is-open');
      fdBackdrop.classList.remove('is-on');
      fdrawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    document.addEventListener('click', (e) => {
      const trig = e.target.closest('[data-fdrawer-open]');
      if (trig) { e.preventDefault(); fdOpen(trig.dataset.fdrawerOpen); }
      if (e.target.closest('[data-fdrawer-close]')) { e.preventDefault(); fdClose(); }
      if (e.target.closest('[data-fdrawer-clear]')) {
        fdrawer.querySelectorAll('input[type="checkbox"]').forEach(i => i.checked = false);
        fdrawer.querySelectorAll('.fdrawer-chip').forEach(c => c.classList.remove('is-on'));
      }
    });
    // Chip toggle visual
    fdrawer.querySelectorAll('.fdrawer-chip input').forEach(i => {
      i.addEventListener('change', () => i.closest('.fdrawer-chip').classList.toggle('is-on', i.checked));
    });
    // Sort radio closes drawer
    fdrawer.querySelectorAll('.fdrawer-sort input').forEach(i => {
      i.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', i.value);
        setTimeout(() => { window.location.href = url.toString(); }, 180);
      });
    });
  })();

  // ---- Legal TOC auto-build + scroll spy ----
  (function () {
    const toc = document.getElementById('legal-toc-list');
    const prose = document.querySelector('.legal-prose');
    if (!toc || !prose) return;

    const headings = prose.querySelectorAll('h2[id]');
    if (!headings.length) return;

    headings.forEach(h => {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      toc.appendChild(li);
    });

    // Scroll spy
    const links = toc.querySelectorAll('a');
    const io = new IntersectionObserver((entries) => {
      const visible = entries
        .filter(e => e.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
      if (visible.length) {
        const id = visible[0].target.id;
        links.forEach(a => a.classList.toggle('is-on', a.getAttribute('href') === '#' + id));
      }
    }, { rootMargin: '-30% 0px -55% 0px', threshold: 0 });

    headings.forEach(s => io.observe(s));
  })();

  // ---- Account tabs ----
  (function () {
    const tabs = document.querySelectorAll('.acct-tab[data-tab]');
    const panels = document.querySelectorAll('.acct-form[data-panel]');
    if (!tabs.length) return;

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('is-on'));
        tab.classList.add('is-on');
        panels.forEach(p => p.hidden = p.dataset.panel !== tab.dataset.tab);
      });
    });
  })();

  // ---- URL hash openers ----
  function applyHashEntry() {
    if (location.hash === '#open-menu') openMnav();
    if (location.hash === '#open-cart') openCart();
  }
  applyHashEntry();

})();